import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import { ThemeColors, ThemeSpace } from '@tanium/theme-data';
import { RED } from '@tanium/colors';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { AppHeaderStyle } from './AppHeaderStyle';
import { TitleBoldText } from '../../TextStyles';
import { useAuthContext } from '../../auth';
import { AsyncStatus } from '../../hooks/useAsync';
import { useAsyncEffect } from '../../hooks/useAsyncEffect';
import { useTenantHook } from '../../hooks/useTenant';
import { getRegionDisplayName } from '../../utilities/constants';

const Container = styled(Box)(
  css({
    color: ThemeColors.Active2,
    bg: ThemeColors.HeaderTier2,
    height: `${AppHeaderStyle.containerHeight}px`,
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    whiteSpace: 'nowrap',
  })
);

const MenuLink = styled(Link)(
  css({
    p: ThemeSpace[1],
    color: ThemeColors.Light0,
    textDecoration: 'none',
    width: '100%',
    display: 'block',
    ':hover': {
      bg: ThemeColors.HeaderTier2,
      color: ThemeColors.HeaderLinkHover,
    },
  })
);

export const AppHeader: React.VFC = () => {
  const { t } = useTranslation();
  const { loginUsername, signOut } = useAuthContext();
  const { loadTenant, tenant } = useTenantHook();

  useAsyncEffect(loadTenant, []);

  return (
    <Box position="fixed" top={0} width="100%" zIndex={1}>
      <Box bg={RED} height={`${AppHeaderStyle.borderHeight}px`} width="100%" />
      <Container>
        <Box mx={3}>
          <Logo />
        </Box>
        <TitleBoldText>{t('Tanium Account')}</TitleBoldText>
        <Box mx={3} flexGrow={1} />
        {loadTenant.status === AsyncStatus.Success && (
          <>
            <Box mx={3}>{`${t('Region')}: ${t(getRegionDisplayName(tenant?.region))}`}</Box>
            <Box ml={ThemeSpace.minor[1]} mr={ThemeSpace.minor[1]}>
              |
            </Box>
          </>
        )}
        <Box mx={3}>{loginUsername}</Box>
        <Box ml={ThemeSpace.minor[1]} mr={ThemeSpace.minor[1]}>
          |
        </Box>
        <Box mx={3}>
          <MenuLink to="" onClick={signOut}>
            {t('Logout')}
          </MenuLink>
        </Box>
      </Container>
    </Box>
  );
};
